/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-constructed-context-values */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { createContext, ReactNode, useContext, useState } from 'react'
import { IAttributes } from 'netshoes/http/types'
import { CategoryInfo } from '../types'

interface AppContextType {
  PRODUCT_NEW_STEPS_FLOW: any
  saveNavigation: any[]
  categoryNavigation: string
  breadcrumbList: BreadcrumbItem[]
  countStep: number
  defaultVariationOptionsByType: any
  blockFieldsVariations: boolean
  modalDataSheetLoading: boolean
  setModalDataSheetLoading: React.Dispatch<React.SetStateAction<boolean>>
  modalDataSheetFormValues: IModalDataSheetFormValues[]
  setModalDataSheetFormValues: React.Dispatch<React.SetStateAction<IModalDataSheetFormValues[]>>
  setBlockFieldsVariations: React.Dispatch<React.SetStateAction<boolean>>
  setCategoryNavigation: React.Dispatch<React.SetStateAction<string>>
  setCountStep: React.Dispatch<React.SetStateAction<number>>
  setBreadcrumbList: React.Dispatch<React.SetStateAction<BreadcrumbItem[]>>
  setSaveNavigation: React.Dispatch<React.SetStateAction<any[]>>
  categoryInfo: CategoryInfo
  setCategoryInfo: React.Dispatch<React.SetStateAction<Partial<CategoryInfo>>>
  attributes: IAttributes[]
  setAttributes: React.Dispatch<React.SetStateAction<IAttributes[]>>
}
interface IModalDataSheetFormValues {
  type: string
  value: string
}
interface BreadcrumbItem {
  type: string
  breadcrumbs: string[]
}

export const AppContext = createContext<AppContextType | undefined>(undefined)

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider')
  }
  return context
}

interface AppProviderProps {
  children: ReactNode
  readyOnlyFieldVariations?: boolean
  initialData: {
    PRODUCT_NEW_STEPS_FLOW: any
    fetchOptions?: () => void
  }
}

export const AppProvider: React.FC<AppProviderProps> = ({
  children,
  initialData,
  readyOnlyFieldVariations,
}) => {
  const { PRODUCT_NEW_STEPS_FLOW, fetchOptions } = initialData
  const [saveNavigation, setSaveNavigation] = useState<any[]>([])
  const [breadcrumbList, setBreadcrumbList] = useState<BreadcrumbItem[]>([])
  const [countStep, setCountStep] = useState(0)
  const [categoryNavigation, setCategoryNavigation] = useState('')
  const [blockFieldsVariations, setBlockFieldsVariations] = useState(!!readyOnlyFieldVariations)
  const [defaultVariationOptionsByType, setDefaultVariatonOptionsByType] = useState<any>('')
  const [modalDataSheetFormValues, setModalDataSheetFormValues] = useState<
    IModalDataSheetFormValues[]
  >([])
  const [attributes, setAttributes] = useState<IAttributes[]>([])
  const [modalDataSheetLoading, setModalDataSheetLoading] = useState(true)
  // eslint-disable-next-line @typescript-eslint/ban-types
  const [categoryInfo, setCategoryInfo] = useState<Partial<CategoryInfo>>({})

  return (
    <AppContext.Provider
      value={{
        defaultVariationOptionsByType,
        PRODUCT_NEW_STEPS_FLOW,
        saveNavigation,
        setSaveNavigation,
        modalDataSheetLoading,
        setModalDataSheetLoading,
        breadcrumbList,
        blockFieldsVariations,
        modalDataSheetFormValues,
        setModalDataSheetFormValues,
        setBlockFieldsVariations,
        setBreadcrumbList,
        countStep,
        setCountStep,
        categoryNavigation,
        setCategoryNavigation,
        categoryInfo,
        setCategoryInfo,
        setDefaultVariatonOptionsByType,
        fetchOptions,
        setAttributes,
        attributes,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
